<!-- 市区町村入力コンポーネント -->
<template>
    <dd :class="validate.$error | klass">
        <template v-if="validate.$error">
            <span v-if="!validate.required"
                  class="errNote"
            >市区町村を入力してください。</span>
        </template>
        <template v-if="validate.$invalid">
            <span v-if="!validate.zenkakuRule"
                  class="errNote"
            >市区町村は全角で入力してください。</span>
            <span v-if="!validate.zenhankakuRule"
                  class="errNote"
            >使用できない文字が含まれています。</span>
            <span v-if="!validate.zenkakuMaxLength"
                  class="errNote"
            >市区町村は26文字以下で入力してください。</span>
        </template>
        <input v-model.lazy="validate.$model"
               @change="setUserInfoPatch"
               name="address_city"
               type="text"
               class="regular"
               id="js-address-city">
    </dd>
</template>

<script>
import { mixinUserInfoFieldComponent } from '../../mixin/utility'

export default {
    name: "UserInfoAddressCityField",
    mixins: [mixinUserInfoFieldComponent],
    props: {
        validate: {
            type: Object,
            required: true
        }
    },
    methods: {
        setUserInfoPatch: function(ev){
            const value = ev.target.value;
            this.$emit('set-user-info-patch', 'address_city', value);
        }
    }
}
</script>
